import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppSettings } from '../../app.settings';
import { Settings } from '../../app.settings.model';
import { LocalStorageKeys } from '../../constants/localStorageKeys.enum';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {

  public appVersion: string = localStorage.getItem(LocalStorageKeys.APP_VERSION);
  public settings: Settings;
  public currentYear: number = null;
  constructor(public appSettings: AppSettings) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/footer/footer.component.ts